export default class BaseHelper
{
    static listeners = {};

    static init()
    {
        window.emit = (topic, params) =>
        {
            if (BaseHelper.listeners[topic])

            {
                for (const listener of BaseHelper.listeners[topic])

                {
                    listener(params);
                }
            }
        };

        window.subscribeToTopic = (topic, cb) =>
        {
            if (BaseHelper.listeners[topic] === undefined)

            {
                BaseHelper.listeners[topic] = [];
            }

            BaseHelper.listeners[topic].push(cb);
        };

        window.deleteTopic = (topic) =>
        {
            if (BaseHelper.listeners[topic] != null)
            {
                delete BaseHelper.listeners[topic];
            }
        };
    }
}
